import React from 'react';
import styles from './Skeletons.module.css';

type IconSkeletonProps = {
    icon: React.ReactNode;
};

function IconSkeleton({ icon }: IconSkeletonProps) {
    return <div className={styles.iconSkeleton}>{icon}</div>;
}

export default IconSkeleton;
